import { Pipe, PipeTransform } from '@angular/core';


const longValues = {
    pidDeleted: 'PID &ndash; Deleted (Subdivision/Assembly)',
    zoningChange: 'Zoning Changes',
    alrChange: 'ALR Status Changes',
    devappsChange: 'Development Application &ndash; New/Status Change/Updated Information',
    landUseChange: 'Land Use Changes (OCP, NCP, LAP)',
    brokerListingsDeleted: 'Broker Listings &ndash; Removed',
    newBrokerListings: 'Broker Listings &ndash; New',
};

@Pipe({
    name: 'notificationType',
})
export class NotificationTypePipe implements PipeTransform {

    transform(value: keyof typeof longValues, length = 'long') {
        if (typeof value !== 'string') {
            return value;
        }

        let formatted = '';

        if (length === 'long') {
            formatted = longValues[value];
        }

        if (typeof formatted === 'undefined') {
            return value;
        }

        return formatted;
    }
}
